import { throttle } from 'lodash';
import React, { useEffect, useState } from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import BackToTopButton from '../global/icons/BackToTop/BackToTop';
import { BackToTopWrapper } from './BackToTop.style';

export const BackToTop = (): React.ReactElement => {
  const [showBackToTopButton, setShowBackToTopButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolledDistance = window.scrollY;
      setShowBackToTopButton(scrolledDistance > 500);
    };

    const scrollHandler = throttle(() => handleScroll(), 600);
    window.addEventListener('scroll', scrollHandler);

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  const handleBackToTop = () => {
    smoothscroll.polyfill();
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  };

  return (
    <>
      {showBackToTopButton && (
        <BackToTopWrapper onClick={handleBackToTop}>
          <BackToTopButton />
        </BackToTopWrapper>
      )}
    </>
  );
};
